import { useState, useEffect } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { getUserDetails, helpapi, helpsupport } from "../Services/Service";
// import required modules
import { Navigation } from "swiper";
import ModalHeader from "react-bootstrap/esm/ModalHeader";

const initialValue = {
  firstName: "",
  lastName: "",
  email: "",
  mobile: "",
  message: "",
};

function AboutUs() {
  const [user, setUser] = useState(initialValue);
  const [support, setSupport] = useState([]);
  const [focus, setFocus] = useState({ message: false, mobile: "", email: "" });
  const [isOpen, setIsOpen] = useState(false);
  const [response, setResponse] = useState("");

  useEffect(() => {
    // if()
    let userId = localStorage.getItem("auth")
      ? localStorage.getItem("auth")
      : 0;
    if (userId !== 0) {
      getUserDetails(userId).then((res) => {
        // console.log(res.data)
        // setUser({userId:res.data.data.userId,firstName:res.data.data.firstName,lastName:res.data.data.lastName,userName:res.data.data.userName,mobile:res.data.data.mobile})
        setUser({ ...user, ...res.data.data });
      });
    }
    helpsupport().then((res) => {
      // console.log(res.data)
      // setUser({userId:res.data.data.userId,firstName:res.data.data.firstName,lastName:res.data.data.lastName,userName:res.data.data.userName,mobile:res.data.data.mobile})
      setSupport([...res.data.data["Support Pending"]]);
    });
  }, []);

  function emailValidation() {
    const regex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!user.email || regex.test(user.email) === false) {
      return false;
    }
    return true;
  }
  const onValueChange = (e) => {
    if (e.target.name == "mobile") {
      if (e.target.value.length <= 10) {
        setFocus({ ...focus, mobile: true });
        if (e.target.name == "mobile" && e.target.value.length === 10) {
          // setFormErrors('');
          setFocus({ ...focus, mobile: false });
        } else {
          // setFormErrors('Please Enter 10 digit mobile no');
        }
        setUser({ ...user, [e.target.name]: e.target.value });
      }
    }
    if (e.target.name == "orderid") {
      setUser({ ...user, [e.target.name]: e.target.value });
    }
    if (e.target.name === "email") {
      const data = emailValidation();
      if (data) {
        // setFormErrors('');
        setFocus({ ...focus, email: false });
        setUser({ ...user, [e.target.name]: e.target.value });
      } else {
        setFocus({ ...focus, email: true });
        setUser({ ...user, [e.target.name]: e.target.value });
      }
    }
    if (e.target.name === "message") {
      // console.log(user.message.length);
      if (e.target.value.length <= 50) {
        setFocus({ ...focus, message: true });
        // setFormErrors('Please Enter atleast 150 letters');
        // setFormErrors('');
        setUser({ ...user, [e.target.name]: e.target.value });
      } else {
        setFocus({ ...focus, message: false });
        // setFormErrors('');
        setUser({ ...user, [e.target.name]: e.target.value });
      }
    }
  };

  function validateForm(e) {
    let ret = true;
    let focus = { mobile: false, email: false, message: false };
    if (user.mobile.length !== 10) {
      // console.log("mobile")
      focus.mobile = true;
      // setFormErrors('Please Enter 10 digit mobile no');
      // return false;
      ret = false;
    }
    const data = emailValidation();
    if (!data) {
      // console.log("email")
      // setFormErrors('Email is invalid');
      focus.email = true;
      // setFocus({...focus, email:true})
      ret = false;
    }
    // console.log(user.message.length)
    if (user.message.length < 50) {
      focus.message = true;
      // console.log("messge",user.message.length)

      ret = false;
    }
    setFocus({ ...focus });
    return ret;
  }

  const submitHandle = (e) => {
    e.preventDefault();
    console.log("clicked button");
    let isvalidForm = validateForm(e);
    if (isvalidForm) {
      helpapi(user).then((response) => {
        //  console.log(response);
        if (response.data.code === 200) {
          setIsOpen(true);
          setResponse(
            `Submit successful. Your support id is: ${response.data.data.supportId}`
          );
          // setFormErrors(`Submit successful. Your support id is: ${response.data.data.supportId}`);
          helpsupport().then((res) => {
            // console.log(res.data)
            // setUser({userId:res.data.data.userId,firstName:res.data.data.firstName,lastName:res.data.data.lastName,userName:res.data.data.userName,mobile:res.data.data.mobile})
            setSupport([...res.data.data["Support Pending"]]);
          });
          setTimeout(() => {
            // setFormErrors("");
            setIsOpen(false);
          }, 2000);
        } else {
          setIsOpen(true);
          setResponse("Oops ! Something went wrong. Try Again");
          setTimeout(() => {
            setIsOpen(false);
          }, 2000);
        }
      });
    }
  };

  return (
    <div className="content-app">
      <>
        <HelmetProvider>
          <Helmet>
            <title>IceSpice | About Us</title>
          </Helmet>
        </HelmetProvider>

        <main className=" container">
          <div className="page-title">
            <h2>About Us</h2>
          </div>
          <div className="page-description">
            {/* <h4> We'd love to hear from you</h4> */}
            <h4> We are open for the feedback</h4>
          </div>
          <div className="rowGap10" />
          <div className="item" style={{ width: "98%" }}>
            <div className="testomonials_card text-center my-1 position-relative">
              <span>
                <i
                  class="fa fa-quote-left"
                  style={{ color: "rgb(225, 100, 113)" }}
                ></i>
              </span>
              <p>
                IceSpice is an innovative loyalty program that provides app
                developers with a powerful platform to elevate user engagement
                and retention strategies. With IceSpice, app developers can
                seamlessly integrate rewarding incentives into their
                applications, incentivizing users to actively participate in
                specific in-app activities. This not only enhances user
                interaction and loyalty but also cultivates a more dynamic and
                committed user community. IceSpice facilitates a win-win
                scenario where developers can drive user engagement while users
                enjoy valuable rewards and benefits within their favorite apps.
              </p>
              <div className="d-flex align-items-center justify-content-center">
                <i className="fa fa-star me-3" style={{ color: "#cd994b" }}></i>
                <i className="fa fa-star me-3" style={{ color: "#cd994b" }}></i>
                <i className="fa fa-star me-3" style={{ color: "#cd994b" }}></i>
                <i className="fa fa-star me-3" style={{ color: "#cd994b" }}></i>
                <i className="fa fa-star me-3" style={{ color: "#cd994b" }}></i>
              </div>
            </div>
          </div>
          <div className="item" style={{ width: "98%" }}>
            <div className="testomonials_card p-4 my-4 mb-4 position-relative">
              <p>
                Address{" "}
                <i
                  class="fa fa-map-marker"
                  style={{ color: "rgb(225, 100, 113)" }}
                ></i>{" "}
                : &nbsp;
                <span style={{ color: "gray" }}>
                  {" "}
                  Interactive icespice technologies private limited , <br />{" "}
                  B-802 Lavista PL-256/257 SEC-10 KharGhar, Raigarh MH 410210 IN{" "}
                </span>
              </p>
              <p>
                E-mail{" "}
                <i
                  class="fa fa-envelope"
                  style={{ color: "rgb(225, 100, 113)" }}
                ></i>{" "}
                &nbsp;: &nbsp;{" "}
                <span style={{ color: "gray" }}> support@icespice.com</span>
              </p>
            </div>
          </div>
          <div className="rowGap10"></div> <div className="rowGap10"></div>
        </main>
      </>
    </div>
  );
}

export default AboutUs;
